export class NgayCong {
    "maLoaiCong": string;
    "tenLoaiCong": string;
    "ngay": Date;
    "ghiChu": string;
}

export class ChamCongNhanVien {
    "idNhanVien": string;
    "maNhanVien": string;
    "tenNhanVien": string;
    "tenChucVu": string;
    "thang": Date;
    "ngayCong": Array<NgayCong>;
}

export class TongHopChamCong {
    "id": number;
    "trangThai": number;
    "idNguoiTrinh": number;
    "trinhPhoCVP": boolean;
    "thangNam": Date;
    "TenNguoiTrinh": string;
}

export class LoaiChamCong {
    "id": number;
    "ten": string;
    "ma": string;
    "cong": number;
    "huongLuong": number;
    "hienThi": boolean;
    "congCoLuong": boolean;
    "anCa": boolean;
    "congTacPhi": boolean;
    "ngayNghiCoLuong": boolean;
    "kyHieu": string;
    "stt": number;
}